import React from 'react'
import './styles.css'

const PlaceholderProducts = () => {
	return (
		<React.Fragment>
			<div className='img-product-placeholder'></div>
			<div className='img-product-placeholder'></div>
			<div className='img-product-placeholder'></div>
			<div className='img-product-placeholder'></div>
			<div className='img-product-placeholder'></div>
		</React.Fragment>
	)
}

export default PlaceholderProducts